var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopHeaderRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 956.5 535.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#047baa;}.cls-2{fill:#ebfaff;}.cls-2,.cls-7,.cls-8,.cls-9{opacity:0.25;isolation:isolate;}.cls-3{fill:#01a09b;}.cls-4,.cls-5{fill:none;stroke:#535461;}.cls-5{stroke-width:2px;}.cls-12,.cls-13,.cls-6{fill:#017572;}.cls-10,.cls-14,.cls-7{fill:#93d502;}.cls-11,.cls-9{fill:#5ec5c1;}.cls-10,.cls-12{opacity:1;}.cls-13{opacity:0.52;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M911.39,246.32V183H873.33v63.31H828.26V148.39h-33V75.19h-27V0H712.09V75.19H685v73.2H653v-88H635V15.84H624V60.35H559.9V341.28H510.78V311.6h-30v29.68H431.66v-95H343.52V183h-38v63.31h-2V368H263.4V296.77H215.33V368H175.27V148.39H144.22V75.19H30.05v73.2H0V535.16H956.46V246.32Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-2",
    x: 18.91,
    y: 174.6,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-2",
    x: 113.89,
    y: 174.6,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-2",
    x: 18.91,
    y: 222.04,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-2",
    x: 113.89,
    y: 222.04,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-2",
    x: 18.91,
    y: 269.47,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-2",
    x: 113.89,
    y: 269.47,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-2",
    x: 18.91,
    y: 316.91,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    className: "cls-2",
    x: 113.89,
    y: 316.91,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    className: "cls-2",
    x: 18.91,
    y: 364.34,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "cls-2",
    x: 113.89,
    y: 364.34,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "cls-2",
    x: 18.91,
    y: 411.78,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "cls-2",
    x: 113.89,
    y: 411.78,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "cls-2",
    x: 18.91,
    y: 458.89,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "cls-2",
    x: 113.89,
    y: 458.89,
    width: 41.79,
    height: 23.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    className: "cls-2",
    x: 191.07,
    y: 399.57,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    className: "cls-2",
    x: 191.07,
    y: 417.73,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    className: "cls-2",
    x: 191.07,
    y: 435.36,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    className: "cls-2",
    x: 447.41,
    y: 405.62,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-2",
    x: 447.41,
    y: 423.79,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "cls-2",
    x: 447.41,
    y: 441.45,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    className: "cls-2",
    x: 191.07,
    y: 453.64,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    className: "cls-2",
    x: 191.07,
    y: 471.91,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    className: "cls-2",
    x: 191.07,
    y: 490.18,
    width: 97.52,
    height: 11.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    className: "cls-2",
    x: 325.06,
    y: 274.58,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    className: "cls-2",
    x: 384.11,
    y: 274.58,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    className: "cls-2",
    x: 325.06,
    y: 331.11,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    className: "cls-2",
    x: 384.11,
    y: 331.11,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    className: "cls-2",
    x: 325.06,
    y: 387.65,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    className: "cls-2",
    x: 384.11,
    y: 387.65,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    className: "cls-2",
    x: 325.06,
    y: 443.82,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    className: "cls-2",
    x: 384.11,
    y: 443.82,
    width: 26.87,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    className: "cls-2",
    x: 560.3,
    y: 83.05,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    className: "cls-2",
    x: 560.3,
    y: 151.46,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    className: "cls-2",
    x: 560.3,
    y: 218.1,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    className: "cls-2",
    x: 560.3,
    y: 284.75,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    className: "cls-2",
    x: 560.3,
    y: 351.39,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    className: "cls-2",
    x: 560.3,
    y: 417.57,
    width: 35.82,
    height: 45.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    className: "cls-2",
    x: 675.35,
    y: 179.71,
    width: 133.34,
    height: 38.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    className: "cls-2",
    x: 675.85,
    y: 264.51,
    width: 133.34,
    height: 38.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    className: "cls-2",
    x: 676.35,
    y: 349.32,
    width: 133.34,
    height: 38.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    className: "cls-2",
    x: 676.84,
    y: 433.72,
    width: 133.34,
    height: 38.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    className: "cls-2",
    x: 29.85,
    y: 97.93,
    width: 17.91,
    height: 37.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-2",
    x: 911.68,
    y: 274.72,
    width: 44.78,
    height: 57.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-2",
    x: 911.68,
    y: 359.57,
    width: 44.78,
    height: 57.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-2",
    x: 911.68,
    y: 444.19,
    width: 44.78,
    height: 57.71
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-3",
    d: "M660.23,459.17s-48.4,29.2,40.82,74.16c0,0,19.68-36.5-2.07-66.25a29.3,29.3,0,0,0-38-8.33Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-4",
    d: "M661.47,458.55s41.42,31.69,40.27,74.78",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-5",
    d: "M704.18,535S689,483.49,707,445.59a81.34,81.34,0,0,0,6.58-51,136.48,136.48,0,0,0-7.22-24",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-6",
    d: "M717.55,342.62c0,6.31-11.43,24.59-11.43,24.59s-11.43-18.3-11.43-24.59a11.43,11.43,0,1,1,22.84-1c0,.16,0,.32,0,.48a3.84,3.84,0,0,1,0,.48Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-6",
    d: "M736.58,378.16c-3.44,5.3-23,14.45-23,14.45s.35-21.57,3.78-26.87a11.43,11.43,0,0,1,19.18,12.42Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-6",
    d: "M735.73,439c-5.64,2.84-27.12.88-27.12.88s11.2-18.44,16.83-21.28a11.43,11.43,0,0,1,10.3,20.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-6",
    d: "M724.86,485c-5.07,3.75-26.58,5.45-26.58,5.45s7.92-20.07,13-23.83A11.43,11.43,0,0,1,724.86,485Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-6",
    d: "M689.45,394.08c4.53,4.4,25.62,8.95,25.62,8.95s-5.16-20.94-9.69-25.35a11.43,11.43,0,0,0-16.34,16h0a5.33,5.33,0,0,0,.42.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-6",
    d: "M677.4,447.94c5.64,2.84,27.12.88,27.12.88s-11.2-18.44-16.83-21.28a11.42,11.42,0,0,0-10.29,20.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-6",
    d: "M672.8,503.12c5.08,3.75,26.59,5.44,26.59,5.44s-7.92-20.07-13-23.82A11.43,11.43,0,0,0,672.59,503Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-7",
    d: "M717.55,342.62c0,6.31-11.43,24.59-11.43,24.59s-11.43-18.3-11.43-24.59a11.43,11.43,0,1,1,22.84-1c0,.16,0,.32,0,.48a3.84,3.84,0,0,1,0,.48Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-8",
    d: "M736.58,378.16c-3.44,5.3-23,14.45-23,14.45s.35-21.57,3.78-26.87a11.43,11.43,0,0,1,19.18,12.42Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-7",
    d: "M735.73,439c-5.64,2.84-27.12.88-27.12.88s11.2-18.44,16.83-21.28a11.43,11.43,0,0,1,10.3,20.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-8",
    d: "M724.86,485c-5.07,3.75-26.58,5.45-26.58,5.45s7.92-20.07,13-23.83A11.43,11.43,0,0,1,724.86,485Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-9",
    d: "M689.45,394.08c4.53,4.4,25.62,8.95,25.62,8.95s-5.16-20.94-9.69-25.35a11.43,11.43,0,0,0-16.34,16h0a5.33,5.33,0,0,0,.42.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-7",
    d: "M677.4,447.94c5.64,2.84,27.12.88,27.12.88s-11.2-18.44-16.83-21.28a11.42,11.42,0,0,0-10.29,20.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-8",
    d: "M672.8,503.12c5.08,3.75,26.59,5.44,26.59,5.44s-7.92-20.07-13-23.82A11.43,11.43,0,0,0,672.59,503Z",
    transform: "translate(0 -0.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-5",
    d: "M940.36,535s-20.26-68.76,3.8-119.37a108.59,108.59,0,0,0,8.78-68.14,182.31,182.31,0,0,0-9.65-32",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-10",
    d: "M956.48,277.73c0,8.43-15.26,32.83-15.26,32.83S926,286.12,926,277.73a15.26,15.26,0,0,1,30.5-1,2.18,2.18,0,0,1,0,.25v.74Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M956.46,311.42c-3.41,9.84-3.8,33.13-3.8,33.13s1.48-.7,3.8-1.85Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M956.46,393.46v-.21c-5.53,7.54-10.28,15.39-10.28,15.39s4.44.4,10.28.67C956.46,404,956.44,398.77,956.46,393.46Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M956.36,468.86c.28-9.16,0-18.28.1-27.65v-.38a15.51,15.51,0,0,0-6.74,2.81c-6.8,5-17.3,31.81-17.3,31.81a221.64,221.64,0,0,0,24-3.31A29.93,29.93,0,0,1,956.36,468.86Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-14",
    d: "M920.77,346.44c6,5.87,34.21,11.95,34.21,11.95s-6.9-28-12.94-33.85a15.26,15.26,0,0,0-21.27,21.9Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-11",
    d: "M904.83,418.39c7.52,3.79,36.21,1.17,36.21,1.17s-14.95-24.63-22.48-28.42a15.26,15.26,0,0,0-13.73,27.25Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-6",
    d: "M898.68,490.7c6.77,5,35.5,7.28,35.5,7.28s-10.58-26.8-17.35-31.82a15.26,15.26,0,1,0-18.15,24.54Z",
    transform: "translate(0 -0.01)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-5",
    d: "M644,535s13.19-44.78-2.48-77.75a70.71,70.71,0,0,1-5.72-44.38A118.48,118.48,0,0,1,642.05,392",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-6",
    d: "M632.31,366.88c0,5.49,10,21.4,10,21.4s10-15.92,10-21.4a10,10,0,0,0-19.9-.28v.28Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-6",
    d: "M615.87,397.76c3,4.6,20,12.56,20,12.56s-.31-18.76-3.3-23.37a10,10,0,1,0-17.19,10A7.26,7.26,0,0,0,615.87,397.76Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-6",
    d: "M616.59,450.59c4.91,2.47,23.6.77,23.6.77s-9.75-16-14.64-18.51a10,10,0,0,0-9,17.75Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-14",
    d: "M626,492.74c4.41,3.26,23.12,4.73,23.12,4.73s-6.88-17.45-11.3-20.71a10,10,0,0,0-11.82,16Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-6",
    d: "M656.72,411.59c-4,3.82-22.28,7.79-22.28,7.79s4.49-18.22,8.43-22a10,10,0,1,1,15.88,12.15A9.75,9.75,0,0,1,657.4,411a8.5,8.5,0,0,1-.68.66Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-14",
    d: "M667.13,458.4c-4.9,2.47-23.59.77-23.59.77s9.74-16,14.64-18.51a10,10,0,0,1,9,17.75Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-6",
    d: "M671.11,507.28C666.69,510.54,648,512,648,512s6.92-17.46,11.3-20.72a10,10,0,0,1,11.82,16Z",
    transform: "translate(0 -0.01)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-2",
    d: "M265.37,47.45h-6.85a4.8,4.8,0,1,0,.81-9.57H203.09a4.8,4.8,0,0,0,0,9.59h6.84a4.8,4.8,0,0,0-.57,9.58h-9a4.8,4.8,0,0,0-.57,9.58h56a4.8,4.8,0,0,0,.81-9.57h8.76a4.8,4.8,0,1,0,.81-9.57H266a2.71,2.71,0,0,0-.57,0Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29-2",
    className: "cls-2",
    d: "M511.65,170.13h-6.84a4.8,4.8,0,0,0,.81-9.57H449.38a4.8,4.8,0,0,0,0,9.58h6.85a4.8,4.8,0,0,0-.57,9.59h-9a4.8,4.8,0,0,0-.59,9.58h56a4.8,4.8,0,0,0,.78-9.57h-.19a2.91,2.91,0,0,0-.59,0h9.58a4.8,4.8,0,1,0,.57-9.59Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30-2",
    className: "cls-2",
    d: "M931.26,10.64h-6.84A4.82,4.82,0,0,0,925,1a5.42,5.42,0,0,0-.57,0H869a4.8,4.8,0,0,0,0,9.59h6.85a4.8,4.8,0,1,0-.81,9.56l.24,0h-9a4.8,4.8,0,0,0-.57,9.58,2.72,2.72,0,0,0,.57,0h55.46a4.8,4.8,0,0,0,0-9.58h9.58a4.8,4.8,0,0,0,.81-9.57h-.81Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31-2",
    className: "cls-2",
    d: "M398.61,359.33l-1.18.87A5.29,5.29,0,0,0,398.61,359.33Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32-2",
    className: "cls-2",
    d: "M399.54,360.28l-1.18.87A5.62,5.62,0,0,0,399.54,360.28Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33-2",
    className: "cls-2",
    d: "M399.54,359.33l-1.18.87A5.29,5.29,0,0,0,399.54,359.33Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46-2",
    className: "cls-5",
    d: "M866.38,535s13.69-46.49-2.57-80.71a73.44,73.44,0,0,1-5.94-46.07,123.81,123.81,0,0,1,6.52-21.65",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47-2",
    className: "cls-14",
    d: "M854.27,361.06c0,5.7,10.32,22.2,10.32,22.2s10.32-16.52,10.32-22.2a10.32,10.32,0,1,0-20.64-.46Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48-2",
    className: "cls-11",
    d: "M837.22,393.15c3.1,4.79,20.74,13,20.74,13s-.32-19.47-3.42-24.26a10.32,10.32,0,1,0-17.88,10.31c.11.18.22.37.34.55s.16.27.25.4Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49-2",
    className: "cls-6",
    d: "M838,448c5.09,2.57,24.48.8,24.48.8s-10.11-16.66-15.2-19.22a10.32,10.32,0,0,0-10,18.07C837.54,447.79,837.77,447.9,838,448Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50-2",
    className: "cls-6",
    d: "M847.72,489.65c4.58,3.39,24,4.92,24,4.92s-7.15-18.12-11.73-21.51a10.32,10.32,0,0,0-12.27,16.59Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51-2",
    className: "cls-14",
    d: "M879.62,407.51c-4.08,4-23.13,8.08-23.13,8.08s4.67-18.91,8.75-22.89a10.32,10.32,0,0,1,14.38,14.8Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52-2",
    className: "cls-11",
    d: "M890.4,456.15c-5.09,2.57-24.48.8-24.48.8s10.11-16.65,15.2-19.22a10.32,10.32,0,0,1,9.28,18.42Z",
    transform: "translate(0 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53-2",
    className: "cls-6",
    d: "M894.56,505c-4.58,3.38-24,4.92-24,4.92s7.15-18.12,11.73-21.51a10.32,10.32,0,1,1,12.65,16.3Z",
    transform: "translate(0 -0.01)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopHeaderRight);
export default __webpack_public_path__ + "static/media/desktop-header-right.16f09d105854d93cea9de35808a5f2a1.svg";
export { ForwardRef as ReactComponent };